import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="text-zinc-500">Loading…</div>
      </div>
    );
  }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) {
      if (user.role === "admin") return <Navigate to="/admin" replace />;
      if (user.role === "clinic_manager") return <Navigate to="/app/clinic" replace />;
      return <Navigate to="/app/dashboard" replace />;
    }
  return children;
}
